module.exports = __webpack_public_path__ + "img/coming-soon-Logo.507b9532.png";